import {ElementRef, Injectable, Renderer2} from '@angular/core';

import {BehaviorSubject, Observable} from 'rxjs';

interface Popover {
  hide: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class PopoverService {
  public isLoadingSubject = new BehaviorSubject<boolean>(false);
  public popoverDataSubject = new BehaviorSubject<any>(null);
  public activePopovers: Popover[] = [];
  public renderer: Renderer2;

  setRenderer(renderer: Renderer2) {
    this.renderer = renderer;
  }

  get isLoading$(): Observable<boolean> {
    return this.isLoadingSubject.asObservable();
  }


  get popoverData$(): Observable<any> {
    return this.popoverDataSubject.asObservable();
  }

  setData(data: any): void {
    this.popoverDataSubject.next(data);
    this.isLoadingSubject.next(false);
  }

  registerPopover(popover: Popover, elementRef: ElementRef): void {
    this.activePopovers.push(popover);
    this.registerClickOutside(popover, elementRef);
  }

  hideAllPopovers(): void {
    this.activePopovers.forEach(popover => popover.hide());
    this.activePopovers = [];
  }

  registerClickOutside(popover: Popover, elementRef: ElementRef): void {
    const clickOutsideHandler = (event: Event) => {
      if (!elementRef.nativeElement.contains(event.target)) {
        popover.hide();
      }
    };

    this.renderer.listen('document', 'click', clickOutsideHandler);
  }
}
